<template>
  <div class="row" id="diagnostico-situacional">
    <div class="col-md-12">
      <b-tabs
        id="tabs-1"
        key="tabs-1"
        fill
        class="esus-feedback-tabs tabs-auto"
        v-model="tabsActive"
      >
        <b-tab
          title="Pessoas por equipe"
          @click="buscarDadosTabelaPessoasPorEquipe()"
        >
          <template v-slot:title>
            <div style="text-transform: initial">
              <i class="icofont-mathematical-alt-1"></i> Pessoas por equipe
            </div>
          </template>
          <table class="mt-4 table table-responsive table-striped">
            <thead>
              <tr class="text-center">
                <th class="text-left">UBS</th>
                <th>CNES</th>
                <th>INE</th>
                <th>TIPO</th>
                <th>PARÂMETRO</th>
                <th style="width: 200px">CADASTROS E-SUS</th>
                <th>MÁXIMO</th>
                <th class="text-left">ATENÇÃO</th>
              </tr>
            </thead>
            <loader-table-skeleton
              :cols="8"
              :rows="10"
              :active="loading"
            ></loader-table-skeleton>
            <tbody v-if="loading == false">
              <tr
                v-for="(item, index) in dadosTabelaPessoasPorEquipe"
                :key="index"
                class="text-center"
                :class="getRowColorTabelaPessoasPorEquipe(item)"
              >
                <td class="text-left">{{ item.no_ubs }}</td>
                <td>{{ item.cnes }}</td>
                <td>{{ item.ine }}</td>
                <td>{{ item.tipo_equipe }}</td>
                <td>{{ item.min_cad }}</td>
                <td>{{ item.denominador }}</td>
                <td>{{ item.max_cad }}</td>
                <td class="text-left">{{ item.recomendacao_cadastro }}</td>
              </tr>
            </tbody>
          </table>
          <div class="input-map-selected">
            <div class="caption-map">
              <span class="caption-item c-orange"></span>
              <span>Cadastro e-SUS &lt; parâmetro</span>
              <span class="caption-item c-green"></span>
              <span>Cadastro e-SUS &gt;= parâmetro e &lt;= máximo</span>
              <span class="caption-item c-red"></span>
              <span>Cadastro e-SUS &gt; máximo</span>
            </div>
          </div>
        </b-tab>
        <b-tab title="Cadastros">
          <template v-slot:title>
            <i class="icofont-mathematical-alt-1"></i> Cadastros
          </template>
          <tabela-cadastros
            ref="table"
            :cadastros="displayedCadastros"
            :loading="loading"
            texto_esus_pec="Cadastros registrados até"
            :data_esus_pec="data_secretaria_de_saude"
            @filterSearch="filterSearch($event)"
          ></tabela-cadastros>
        </b-tab>
        <b-tab title="Acompanhamento">
          <template v-slot:title>
            <i class="icofont-mathematical-alt-1"></i> Acompanhamento
          </template>
          <tabela-cadastros
            ref="table"
            :cadastros="displayedAcompanhamento"
            :loading="loading"
            texto_esus_pec="Cadastros registrados até"
            :data_esus_pec="data_secretaria_de_saude"
            @filterSearch="filterSearch($event)"
          ></tabela-cadastros>
        </b-tab>
        <b-tab title="Mapa" @click="buscarDadosDoMapa()">
          <template v-slot:title>
            <i class="icofont-ui-map"></i> Mapa
          </template>
          <div class="row">
            <mapa :dadosResultado="dadosResultado" ref="mapa" />
          </div>
          <div class="input-map-selected">
            <div class="caption-map">
              <span class="caption-item c-orange"></span>
              <span>Cadastro e-SUS &lt; parâmetro</span>
              <span class="caption-item c-green"></span>
              <span>Cadastro e-SUS &gt;= parâmetro e &lt;= máximo</span>
              <span class="caption-item c-red"></span>
              <span>Cadastro e-SUS &gt; máximo</span>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Subtitle from './Subtitle'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import * as Functions from './functions.js'
import * as Filter from './filter.js'
import utils from '@/mixins/utils.js'
import TitleTag from '@/components/TitleTag.vue'
import TabelaCadastros from './TabelaCadastros.vue'
import LoaderTableSkeleton from '@/components/LoaderTableSkeleton.vue'
import Mapa from './Mapa.vue'

export default {
  name: 'DiagnosticoSituacional',
  components: {
    Subtitle,
    TitleTag,
    PulseLoader,
    TabelaCadastros,
    LoaderTableSkeleton,
    Mapa,
  },
  mixins: [utils],
  data() {
    return {
      size: '40px',
      color: '#0D98BB',
      id_funcao: '',
      cod_ibge: '',
      user_id: '',
      data_secretaria_de_saude: '',
      loading: false,
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      tabsActive: 0,
      filterSearchTable: false,
      setRed: false,
      dadosResultado: [],
      dadosDasEquipes: [],
      dadosCadastros: [],
      dadosAcompanhamento: [],
      dadosTabelaPessoasPorEquipe: [],
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      let response = Filter.filtro(
        this.dadosCadastros,
        this.exibirCadastrosVermelhos,
        this.exibirCadastrosVerdes
      )
      if (response === undefined) {
        response = []
      }
      return response
    },
    displayedAcompanhamento() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      let response = Filter.filtro(
        this.dadosAcompanhamento,
        this.exibirCadastrosVermelhos,
        this.exibirCadastrosVerdes
      )
      if (response === undefined) {
        response = []
      }
      return response
    },
  },

  methods: {
    filtros(vermelho, verde) {
      if (this.$refs.table) {
        this.$refs.table.search = ''
      }
      if (vermelho === true) {
        this.setRed = true
        this.exibirCadastrosVerdes = false
        this.exibirCadastrosVermelhos = true
      }
      if (verde === true) {
        this.setRed = false
        this.exibirCadastrosVermelhos = false
        this.exibirCadastrosVerdes = true
      }
    },

    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    handleExibirVermelhos(event) {
      if (event == true) {
        // mostra os vermelhos
        this.filtros(true, false)
        this.exibirCadastrosVermelhos = true
        this.exibirCadastrosVerdes = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVermelhos = false
      }
    },

    handleExibirVerdes(event) {
      if (event == true) {
        // mostra os verdes
        this.filtros(false, true)
        this.exibirCadastrosVerdes = true
        this.exibirCadastrosVermelhos = false
      } else {
        this.filtros(false, false)
        this.exibirCadastrosVerdes = false
      }
    },

    getRowColorTabelaPessoasPorEquipe(item) {
      return Functions.getRowColorTabelaPessoasPorEquipe(item)
    },

    buscarDadosTabelaPessoasPorEquipe() {
      this.dadosTabelaPessoasPorEquipe = this.dadosResultado.filter((item) => {
        return item.indicador == '0' && item.ine !== null
      })
    },

    buscarDadosDoMapa() {
      this.$refs.mapa.initMap()
    },

    async buscarDadosIniciais() {
      try {
        this.loading = true
        let response = await this.$api.get(
          `/app/diagnostico-situacional/${this.cod_ibge}/consolidado/[0,27,28,29,30]`
        )
        if (response) {
          this.dadosDasEquipes = response.data
          this.dadosCadastros = response.data.filter((el) => {
            return (
              el.indicador == '0' ||
              el.indicador == '27' ||
              el.indicador == '28' ||
              el.indicador == '29'
            )
          })
          this.dadosAcompanhamento = response.data.filter((el) => {
            return el.indicador == '30'
          })
        }

        let response2 = await this.$api.get(
          '/app/indicadores-aps/resultado/' + this.cod_ibge + '/[0,27,28,29,30]'
        )
        if (response2) {
          this.dadosResultado = response2.data
          this.buscarDadosTabelaPessoasPorEquipe()
          this.buscarDadosDoMapa()
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    async buscarUltimaAtualizacao() {
      let response = await Functions.getUltimaAtualizacao(this.cod_ibge)
      if (response) {
        this.data_secretaria_de_saude = this.formatDate(
          response.data_sincronizacao
        )
      }
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedEquipes,
        this.equipe,
        this.profissional,
        this.nomeProfissional,
        this.data_secretaria_de_saude
      )
    },

    init() {
      this.id_funcao = this.$store.state.id_funcao
      this.user_id = this.$store.state.id
      this.cod_ibge = this.$store.state.cod_ibge
      this.buscarUltimaAtualizacao()
      this.buscarDadosIniciais()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style>
.green {
  color: green;
}
.red {
  color: red;
}
.orange {
  color: orange;
}

@media (max-width: 768px) {
  button {
    margin-top: 0;
  }
}

.map-radius {
  background-color: transparent;
  border: none;
  box-shadow: none;
  color: #fff;
  font-weight: 700;
}
</style>
<style scoped>
.filter-table .filter-table-item .input-idade {
  flex-wrap: nowrap;
}
</style>
<style src="./styles.scss" scoped lang="scss" />
